// Components
import Field from 'components/form/field'
import { TextInput } from 'components/form/text-input'
// Modules
import { DI } from 'modules'
import PaymentBlock, {
  PaymentBlockFields,
} from 'pages/business/components/payment-block'
import * as React from 'react'
import Select from 'components/form/select-input'
import RadioButton from 'components/form/radio'

const SetUpAccount = ({
  common: { strings },
  form: { user },
  onValidateForm,
  geodata,
}) => {
  const country =
    geodata.countries.payload.find(({ id }) => id === +user.country_id) || {}

  return (
    <PaymentBlock
      text={strings['header.profile.setUp.text']}
      title={strings['header.profile.setUp.title']}
    >
      <PaymentBlockFields>
        <Field label={strings[`page.billing.form.iam`]} labelNotPadded>
          <div className="buying__billing-type">
            <RadioButton
              checked={user?.not_a_company}
              disabled={country.code === 'RU'}
              name="user[not_a_company]"
              value
            >
              {strings[`page.billing.form.individual`]}
            </RadioButton>
            <RadioButton
              checked={!user?.not_a_company}
              name="user[not_a_company]"
              value={false}
            >
              {strings[`page.billing.form.company`]}
            </RadioButton>
          </div>
        </Field>
        <div className="field-hr" />

        <Field label={strings['page.confirmation.first_name']}>
          <TextInput
            isLatin
            isRequired
            name="user[first_name]"
            onValidateForm={onValidateForm}
            value={user.first_name}
          />
        </Field>

        <Field label={strings['page.confirmation.last_name']}>
          <TextInput
            isLatin
            isRequired
            name="user[last_name]"
            onValidateForm={onValidateForm}
            value={user.last_name}
          />
        </Field>

        <Field label={strings['page.confirmation.country']}>
          <Select
            getTitle={item => item.name}
            getValue={item => item.id}
            headerModificator={'sign-in'}
            isInput
            isRequired
            items={geodata.countries.payload}
            modificator={'sign-in'}
            name="user[country_id]"
            notSelected
            onValidateForm={onValidateForm}
            value={Number(user.country_id)}
            wrapSelect
          />
        </Field>

        {!user.not_a_company && (
          <Field label={strings['page.confirmation.company']}>
            <TextInput
              isLatin
              isRequired={!user?.not_a_company}
              name="user[company_name]"
              onValidateForm={onValidateForm}
              value={user.company_name}
            />
          </Field>
        )}

        <div className="field-hr" />

        <Field label={strings['page.confirmation.password']}>
          <TextInput
            autoComplete="new-password"
            isPassword
            isRequired
            name="user[password]"
            ok
            onValidateForm={onValidateForm}
            type="password"
            value={user.password}
          />
        </Field>

        <Field label={strings['page.confirmation.confirm_password']}>
          <TextInput
            autoComplete="new-password"
            isPassword
            isRequired
            name="user[password_confirmation]"
            ok
            onValidateForm={onValidateForm}
            type={'password'}
            validators={[
              {
                name: 'isEq',
                params: user.password,
                message: strings['passwordConfirmationError'],
              },
            ]}
            value={user.password_confirmation}
          />
        </Field>

        <div
          className="popup-button"
          style={{ maxWidth: '100px', margin: '20px 0 0' }}
        >
          <button
            className="button"
            type="submit"
            data-action-name="set up step"
          >
            {strings['signup.signin.next']}
          </button>
        </div>
      </PaymentBlockFields>
    </PaymentBlock>
  )
}

export default DI(['common', 'geodata'])(SetUpAccount)
